import { render, staticRenderFns } from "./TaskDistribution.vue?vue&type=template&id=2534b6fa"
import script from "./TaskDistribution.vue?vue&type=script&lang=js"
export * from "./TaskDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports